import { Grid } from '@mui/material'
import React, { Fragment, useState } from 'react'
import ReaderCreateView from '../../../components/front_office/reader/ReaderCreateView'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';
import ReaderListView from '../../../components/front_office/reader/ReaderListView';

const FrontReaderAddListView = () => {
  const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/reader/create/new/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
  return (
    <Fragment>
    <Grid container spacing={3}>
        <Grid item xl={3} md={3} sm={12} xs={12} lg={4}>
            <ReaderCreateView handleFormSuccess={handleFormSuccess} />
        </Grid>
        <Grid item xl={9} md={9} sm={12} xs={12} lg={8}>
            <ReaderListView setOnURL={setOnURL} data={data} handleFormSuccess={handleFormSuccess} error={error} loading={loading} />
        </Grid>
    </Grid>

</Fragment>
  )
}

export default FrontReaderAddListView